import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { api } from "../utils/api";
import "./BottomNav.css";

interface NavItem {
  path: string;
  label: string;
  icon: string;
  showBadge?: boolean;
}

const navItems: NavItem[] = [
  { path: "/home", label: "Home", icon: "🏠" },
  { path: "/workouts", label: "Workouts", icon: "💪" },
  { path: "/food", label: "Food", icon: "🍎" },
  { path: "/progress", label: "Progress", icon: "📊" },
  { path: "/messages", label: "Messages", icon: "💬", showBadge: true },
  { path: "/more", label: "More", icon: "☰" },
];

export function BottomNav() {
  const [unread, setUnread] = useState<number>(0);

  useEffect(() => {
    let cancelled = false;
    async function loadUnread() {
      try {
        const data = await api.get<{ count: number }>(
          "/api/messages/unread-count",
        );
        if (!cancelled) setUnread(data?.count ?? 0);
      } catch {
        /* ignore polling errors */
      }
    }
    loadUnread();
    const interval = setInterval(loadUnread, 30000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          style={{ minWidth: 50 }}
        >
          <span style={{ position: "relative", display: "inline-block" }}>
            <span className="nav-icon">{item.icon}</span>
            {item.showBadge && unread > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: -4,
                  right: -10,
                  minWidth: 16,
                  height: 16,
                  borderRadius: 8,
                  backgroundColor: "#e53935",
                  color: "#fff",
                  fontSize: 10,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 4px",
                  lineHeight: 1,
                  boxSizing: "border-box",
                  border: "1.5px solid #1a1a1a",
                }}
                aria-label={`${unread} unread messages`}
              >
                {unread > 9 ? "9+" : unread}
              </span>
            )}
          </span>
          <span className="nav-label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
